module.exports = __webpack_public_path__ + "img/gallery08-1.82162b2d.jpg";